'use client';

import { FunctionComponent, lazy, Suspense } from 'react';
import { TotaliserProps, TotaliserThemeProps } from '../Totaliser/props';
import DefaultTheme from '../Totaliser/themes/DefaultTheme/DefaultTheme';
import { Totaliser } from '../Totaliser/Totaliser';

export type TotaliserThemeName = 'default' | 'london-eye';

export type ThemedTotaliserProps = Omit<TotaliserProps, 'theme'> & {
  themeName?: TotaliserThemeName;
};

export const ThemedTotaliser: FunctionComponent<ThemedTotaliserProps> = ({
  themeName = 'default',
  ...totaliserProps
}) => {
  return (
    <Suspense>
      <Totaliser {...totaliserProps} theme={getThemeComponent(themeName)} />
    </Suspense>
  );
};

function getThemeComponent(
  themeName: TotaliserThemeName,
): FunctionComponent<TotaliserThemeProps> {
  switch (themeName) {
    case 'london-eye':
      return lazy(
        () => import('../Totaliser/themes/LondonEyeTheme/LondonEyeTheme'),
      );
    case 'default':
      return DefaultTheme;
  }
}
